import ReactDOM from 'react-dom/client';

// styles
import './index.scss';
import App from './pages/App/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
